import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=ece5156c&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"
import style0 from "./Patient.vue?vue&type=style&index=0&id=ece5156c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece5156c",
  null
  
)

export default component.exports